export default __webpack_public_path__ + "static/AGaramondPro-Semibold-fa9e5cc67664fd43cfa43283055da403.otf";